<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 1500px"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSegment">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />{{ titleItem }} - {{ segmentName }}
        </v-btn>
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard">
        <CardsView
          :items="elements"
          :openDialog="openDialog"
          :title="title"
          @refreshItems="refreshItems"
          :showRefresh="true"
          :showReuse="true"
          :showDelRelation="true"
        />
      </div>
      <div v-else>
        <TableWithSearch
          :items="elements"
          :headers="allHeaders"
          :title="title"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
          :showReuse="true"
          :showDelRelation="true"
        />
      </div>
    </v-col>
    <v-dialog
      v-model="openElement"
      max-width="600px"
      persistent
      @keydown.esc="reset(false)"
    >
      <FormElement
        @save="saveForm"
        @cancel="reset"
        :mode="mode"
        :itemsElement="itemSelected"
        :titleItem="titleItem"
      >
      </FormElement>
    </v-dialog>
    <v-dialog
      v-model="openReuseElement"
      max-width="600px"
      persistent
      @keydown.esc="reset(false)"
    >
      <Form
        :items="dataReuseElement"
        @save="saveReuseElement"
        @cancel="reset"
        :maxWidth="maxWidth"
        :mode="mode"
        :show="true"
        :itemsSelect="dataReuseSelected"
        :titleItem="titleItem"
      />
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
      :maxWidth="'500px'"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-row>
</template>
<script>
import schedules from "@/store/horarios/schedules";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import FormElement from "./Forms/FormElement.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import process from "@/store/workflow/process";
import moment from "moment";
import Loader from "@/components/Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
export default {
  components: {
    Form,
    DeleteDialog,
    Snackbar,
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    FormElement,
    Loader,
  },

  data() {
    return {
      showCard: true,
      title: "Elementos",
      titleTable: "Horarios_Elementos",
      titleDelete: this.$tc("schedules.toElement"),
      color: "",
      alert: false,
      textAlert: "",
      isLoading: true,
      headers: [
        {
          text: "Elementos",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Entrada",
          value: "from",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Salida",
          value: "to",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tol. entrada",
          value: "tolEnt",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tol. salida",
          value: "tolSal",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Concepto",
          value: "conceptName",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Laboral",
          value: "laboral",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          visible: true,
          class: "primary secondary--text",
          sortable: false,
          width: "150px",
        },
      ],
      idElement: null,
      itemSelected: {},
      openReuseElement: false,
      maxWidth: "600px",
    };
  },
  mounted() {
    schedules.dispatch("getElements").then(() => {
      this.isLoading = false;
    });
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },

  computed: {
    segmentName() {
      const segment = schedules.state.segments.find(
        (segment) => segment.segmId === schedules.state.segmentId,
      );
      return segment ? segment.name : "Segmento";
    },
    dataReuseElement() {
      return [];
    },
    dataReuseSelected() {
      return [
        {
          name: "element",
          label: "Elemento a reutilizar",
          data: null,
          items: this.elementsAll,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
    elementsAll() {
      return schedules.state.elementsAll;
    },
    allHeaders() {
      return configTable.state.colums;
    },
    concepts() {
      return process.state.concept.filter((e) => e.horTrab == "S");
    },
    segment() {
      return schedules.state.segments;
    },
    mode: {
      get() {
        return schedules.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    padding() {
      return schedules.state.paddingNav;
    },
    elements() {
      return schedules.state.elements;
    },
    openElement: {
      get() {
        return schedules.state.openElement.value;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return schedules.state.openDeleteEle;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    dataElement() {
      return {
        timeFrom: null,
        timeTo: null,
        element: {
          label: "Nombre",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v.length <= 50 || this.$tc("schedules.rulesDataSchedules"),
          ],
        },
        from: {
          label: this.$tc("date.from"),
          data: "00:00",
          type: "time",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
        to: {
          label: this.$tc("date.to"),
          data: "00:00",
          type: "time",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
        entryTolerance: {
          name: "entryTolerance",
          label: this.$tc("schedules.entryTolerance"),
          data: moment("00:10", "HH:mm").format("HH:mm"),
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              /^[0-9]{1,2}:[0-9]{1,2}$/.test(v) || "Solo se permiten números",
          ],
        },
        exitTolerance: {
          name: "exitTolerance",
          label: this.$tc("schedules.exitTolerance"),
          data: moment("00:10", "HH:mm").format("HH:mm"),
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              /^[0-9]{1,2}:[0-9]{1,2}$/.test(v) || "Solo se permiten números",
          ],
        },
        dayFrom: {
          label: this.$tc("schedules.day"),
          data: 1,
          items: [
            { id: 0, name: "Anterior" },
            { id: 1, name: "Actual" },
            { id: 2, name: "Posterior" },
          ],
          itemsValue: "id",
          itemsText: "name",
        },
        dayTo: {
          label: this.$tc("schedules.day"),
          data: 1,
          items: [
            { id: 0, name: "Anterior" },
            { id: 1, name: "Actual" },
            { id: 2, name: "Posterior" },
          ],
          itemsValue: "id",
          itemsText: "name",
        },
        concept: {
          label: "Conceptos",
          data: this.concepts[0],
          items: this.concepts,
          itemsValue: "id",
          itemsText: "name",
        },

        mts: {
          label: this.$tc("schedules.mts"),
          data: "00:30",
          type: "text",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
        roundingFraction: {
          label: this.$tc("schedules.roundingFraction"),
          data: 30,
          items: [
            { id: 1, name: "1 minuto" },
            { id: 10, name: "10 miutos" },
            { id: 15, name: "15 minutos" },
            { id: 30, name: "30 minutos" },
            { id: 60, name: "60 minutos" },
          ],
          itemsValue: "id",
          itemsText: "name",
        },
        porcentage: {
          label: this.$tc("schedules.porcentage"),
          data: 50,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v <= 100 || this.$tc("schedules.rulesPorcentage"),
          ],
        },
        labor: { label: this.$tc("schedules.labor"), data: false },
        noHolidays: {
          label: this.$tc("schedules.applyNotHoliday"),
          data: true,
        },
        holidays: { label: this.$tc("schedules.applyHolidays"), data: false },
      };
    },
    titleItem() {
      const schedule = schedules.state.schedules.find(
        (schedule) => schedule.id === schedules.state.scheduleId,
      );
      return schedule ? schedule.name : "Horario";
    },
  },

  methods: {
    saveReuseElement(items) {
      this.isLoading = true;
      const payload = {
        id: Number(items.element),
        segmentId: schedules.state.segmentId,
      };
      schedules.commit("setNewElement", payload);
      schedules
        .dispatch("reuseElement")
        .then(() => {
          this.isLoading = false;
          this.openReuseElement = false;
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addElementAlert");
        })
        .catch((e) => {
          this.isLoading = false;
          this.color = "#FF8D58";
          this.alert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.refreshItems();
      this.reset(false);
    },
    async refreshItems() {
      await schedules.dispatch("getElements");
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    goToSegment() {
      schedules.dispatch("handleShowWindow", "segment");
    },
    async openDialog(type, item) {
      await process.dispatch("getConcept").then(() => {
        this.itemSelected = this.dataElement;
        this.typeForm = type;
      });

      let payload = {
        type: "card",
        value: true,
      };

      switch (this.typeForm) {
        case "reuse":
          await schedules.dispatch("getElementsAll");
          schedules.commit("setMode", this.$tc("schedules.reuseElement"));
          this.openReuseElement = true;
          break;
        case "add":
          schedules.commit("setMode", this.$tc("schedules.addElement"));
          schedules.commit("setOpenElement", payload);
          this.mode = "Agregar elemento";

          break;
        case "edit":
          this.idElement = item.id;
          schedules.commit("setMode", this.$tc("schedules.editElement"));
          schedules.commit("setOpenElement", payload);
          this.mode = "Editar elemento";
          this.itemSelected.noHolidays.data = item.aplNoFeriados;
          this.itemSelected.holidays.data = item.aplFeriados;
          this.itemSelected.concept.data = item.conceptId;
          this.itemSelected.dayFrom.data = item.from <= -1 ? 0 : 1;
          this.itemSelected.dayTo.data = item.to > 1440 ? 2 : 1;
          this.itemSelected.roundingFraction.data = item.fracRed;
          this.itemSelected.labor.data = item.laboral;
          this.itemSelected.mts.data = item.mts;
          this.itemSelected.element.data = item.name;
          this.itemSelected.porcentage.data = item.porcen;
          this.itemSelected.entryTolerance.data = item.tolEnt;
          this.itemSelected.exitTolerance.data = item.tolSal;
          this.itemSelected.timeFrom = moment()
            .startOf("day")
            .add(item.from, "minutes")
            .format("HH:mm");
          this.itemSelected.timeTo = moment()
            .startOf("day")
            .add(item.to, "minutes")
            .format("HH:mm");

          break;
        case "delete":
          this.idElement = item.id;
          schedules.commit("setOpenDeleteEle", true);
          this.titleDelete = this.$tc("schedules.toElement");
          break;
        case "deleteRelation":
          this.titleDelete = this.$tc("schedules.deleteRelationElementConfirm");
          schedules.commit("setOpenDeleteEle", true);
          this.idElement = item.id;
          break;
        default:
          break;
      }
    },

    cardView(value) {
      this.showCard = value;
    },
    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addElement(items);
          break;
        case "edit":
          this.editElement(items);
          break;
        default:
          break;
      }
    },
    addElement(items) {
      schedules.commit("setNewElement", items);
      schedules
        .dispatch("newElement")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addElementAlert");
        })
        .catch((e) => {
          this.catchError(e);
        });
      this.reset(false);
    },
    editElement(items) {
      let payload = {
        ...items,
        id: this.idElement,
      };
      schedules.commit("setEditElement", payload);
      schedules
        .dispatch("editElement")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.editElementAlert");
        })
        .catch((e) => {
          this.catchError(e);
        });
      this.reset(false);
    },
    convertMinutesToHHMM(minutes) {
      const hours = Math.floor(minutes / 60);
      const minutesRemainder = minutes % 60;

      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutesRemainder).padStart(2, "0");

      return `${formattedHours}:${formattedMinutes}`;
    },
    catchError(e) {
      this.color = "#FF8D58";
      this.alert = true;
      this.textAlert = e.response.data.error.message;
    },

    reset(value) {
      schedules.commit("setOpenElement", value);
      this.alert = false;
      this.dataElement.element.data = "";
      this.dataElement.timeFrom = null;
      this.dataElement.timeTo = null;
      this.dataElement.entryTolerance.data = "00:10";
      this.dataElement.exitTolerance.data = "00:10";
      this.dataElement.dayFrom.data = 1;
      this.dataElement.dayTo.data = 1;
      this.dataElement.concept.data = 1;
      this.dataElement.mts.data = "00:30";
      this.dataElement.roundingFraction.data = 30;
      this.dataElement.porcentage.data = 50;
      this.dataElement.labor.data = false;
      this.dataElement.noHolidays.data = true;
      this.dataElement.holidays.data = false;
      this.dataElement.disabledDayFrom = false;
      this.dataElement.disabledDayTo = false;
      this.openReuseElement = false;
      this.dataReuseSelected.forEach((item) => {
        item.data = null;
      });
    },
    deleteItem() {
      if (
        this.titleDelete === this.$tc("schedules.deleteRelationElementConfirm")
      ) {
        schedules.commit("setItemDelete", {
          elemId: this.idElement,
          segmentId: schedules.state.segmentId,
        });

        schedules
          .dispatch("deleteElementRelation")
          .then(() => {
            this.isLoading = false;
            this.refreshItems();
            this.openDelete = false;
            schedules.commit("setOpenDeleteSeg", false);
            this.alert = true;
            this.color = "#82A1D0";
            this.textAlert = this.$tc("schedules.deleteRelationAlert");
          })
          .catch((e) => {
            this.isLoading = false;
            this.color = "#FF8D58";
            this.alert = true;
            this.textAlert = e.response.data.error.message;
          });
        this.cancelDelete();
      } else {
        schedules.commit("setItemDelete", this.idElement);
        schedules
          .dispatch("deleteElement")
          .then(() => {
            this.alert = true;
            this.color = "#82A1D0";
            this.textAlert = this.$tc("schedules.deleteElement");
          })
          .catch((e) => {
            this.color = "#FF8D58";
            this.alert = true;
            this.textAlert = e.response.data.error.message;
          });
        this.openDelete = false;
        schedules.commit("setOpenDeleteEle", false);
        this.cancelDelete();
      }
    },
    cancelDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDeleteEle", false);
    },
  },
};
</script>
<style scoped></style>
